import {Button, Container} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ModalDommusTSX} from "../../../../../../components/ModalTS";
import React, {useContext, useEffect, useState} from "react";
import {RenegociacaoContext} from "../../../../../../contexts/RenegociacaoContext";
import { SimuladorFinanceiro } from "./SimuladorFinanceiro";
import RenegociacaoService from "../../../../../../services/RenegociacaoService";
import {NegociacaoParametros, RenegociacaoProps, ParcelasType} from "./types";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { trackPromise } from "react-promise-tracker";
import HistoricoRenegociacoes from "./HistoricoRenegociacoes";

export function Renegociacao({ ticket }: RenegociacaoProps) {
  const { modalRenegociacaoAberto, fecharModalRenegociacao, abrirModalRenegociacao, renegociacoes, abrirModalValidacao, buscarRenegociacao } = useContext(RenegociacaoContext)
  const [parcelas, setParcelas] = useState<ParcelasType | null>(null);
  const [negociacaoParametros, setNegociacaoParametros] = useState<NegociacaoParametros | null>(null);
  const [permissaoDataCorte, setPermissaoDataCorte] = useState<boolean>(false);
  const [dataCorte, setDataCorte] = useState<string>('');
  const [podeCriar, setPodeCriar] = useState<boolean>(false);
  const [parcelasLoading, setParcelasLoading] = useState<boolean>(false);
  
  const handleAbrirRenegociacao = async () => {
    if (!ticket) return;
    const idProcesso = ticket.id_processo;
    
    setParcelasLoading(true);
    abrirModalRenegociacao();
    
    trackPromise(
      Promise.all([
        RenegociacaoService.buscarParcelas(idProcesso),
        RenegociacaoService.buscarParametrosSimuladorRenegociacao(ticket.id_processo)
      ])
        .then((response) => {
          setParcelas(response[0].data.parcelas);
          setNegociacaoParametros(response[1].data.parametros);
          setParcelasLoading(false);
        })
        .catch((error) => {
          swal(
            "Ooops...",
            "Ocorreu um erro ao buscar as dados: " + error,
            "error"
          );
          setParcelasLoading(false);
        })
    );
  };

  useEffect(() => {
    trackPromise(RenegociacaoService.buscarPermissaoDataCorte(ticket.id_processo)).then((response) => {
      setPermissaoDataCorte(response.data.renegociacaoComDataCorte);
    });
  }, [ticket.id_processo]);

  
  useEffect(() => {
    if (!ticket || !ticket.id_processo) return;
    try {
      buscarRenegociacao(ticket.id_processo);
    } catch (e) {
      console.error('Erro ao buscar renegociacoes no contexto', e);
    }
  }, [ticket.id_processo, buscarRenegociacao]);

  const buscarParcelasPorDataCorte = (novaDataCorte: string) => {
    setDataCorte(novaDataCorte);
    if(!ticket) return;
    const idProcesso = ticket.id_processo;

    trackPromise(RenegociacaoService.buscarParcelas(idProcesso, novaDataCorte))
      .then((response) => {
        const novasAtrasadas = response?.data?.parcelas?.atrasada;
        setParcelas((prev) => {
          if (!prev) {
            return { atrasada: novasAtrasadas } as ParcelasType;
          }
          return { ...prev, atrasada: novasAtrasadas } as ParcelasType;
        });
      })
      .catch(() => {
        Swal.fire({
          titleText: "Erro!",
          text: `Erro ao buscar parcelas por data de corte`,
          icon: "warning",
        });
      });
  };

  return (
    <Container className="py-3 fundo-cinza-claro">
      <HistoricoRenegociacoes
        renegociacoes={renegociacoes}
        ticket={ticket}
        onPodeCriarChange={setPodeCriar}
      />

        <div className="mt-2 text-right">
          <Button variant="success" size="sm" onClick={() => handleAbrirRenegociacao()} disabled={!podeCriar || parcelasLoading}>
            <FontAwesomeIcon icon="plus-circle" /> Nova Renegociacao
          </Button>
        </div>

      <ModalDommusTSX
        bodyStyle={{ padding: 0, overflow: "scroll", maxHeight: "82vh" }}
        titulo={'Renegociação de Valores'}
        open={modalRenegociacaoAberto}
        close={fecharModalRenegociacao}
        content={<SimuladorFinanceiro parcelas={parcelas} closeModal={fecharModalRenegociacao} negociacaoParametros={negociacaoParametros} ticket={ticket} dataCorte={dataCorte} abrirModalValidacao={abrirModalValidacao} parcelasLoading={parcelasLoading}/>} 
        permissaoDataCorte={permissaoDataCorte}
        dataCorte={dataCorte}
        buscarParcelasPorDataCorte={buscarParcelasPorDataCorte}
      />
    </Container>
  );
}